import React__default from 'react';
import { MgirlNotice, EMGirlType } from '../../../../../mgirl-notice/index.js';
import '../../../../../utils/fetcher.js';
import { prependPrefix } from '../../../../../utils/style.js';

var FailedNotice = function FailedNotice() {
  return /*#__PURE__*/React__default.createElement(MgirlNotice, {
    className: prependPrefix('failed-notice-container'),
    description: "\u52A0\u8F7D\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
    descriptionClassName: "failed-notice-info",
    image: EMGirlType.Alone,
    imageClassName: "failed-notice-mgirl"
  });
};

export { FailedNotice };
